// Texty expedice (dispatchEta.js). Názvy dnů jsou JEDINÝ seznam webu — čtou je
// i deliveryTimeline.js a shippingModel.js (locale/cs/*.js je importují odsud).
export default {
  /** prefix popisku karty výpisu; SK musí začínat týmž slovem (cartModal.sendsFrom) */
  prefix: 'Expedujeme ',
  today: 'dnes',
  tomorrow: 'zítra',
  /** 0 = neděle, tvar „v pondělí" */
  days: ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'],
};
